import React, { useMemo } from 'react';

interface Region {
  name: string;
  shortCode?: string;
}

interface CountryData {
  countryName: string;
  countryShortCode: string;
  regions: Region[];
}

let cachedCountryData: CountryData[] | null = null;

const loadCountryData = async (): Promise<CountryData[]> => {
  if (cachedCountryData) return cachedCountryData;

  const res = await fetch('/static/country-region.json');
  if (!res.ok) return [];
  const json = await res.json();
  cachedCountryData = json as CountryData[];
  return cachedCountryData;
};

export function useCountryRegion() {
  const [countries, setCountries] = React.useState<CountryData[]>([]);

  React.useEffect(() => {
    let mounted = true;
    loadCountryData().then((data) => {
      if (mounted) setCountries(data);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const countryOptions = useMemo(
    () =>
      countries.map((c) => ({
        k: c.countryShortCode,
        v: c.countryName,
      })),
    [countries]
  );

  const getProvinceOptions = (countryShortCode?: string | null) => {
    if (!countryShortCode) return [];
    const country = countries.find(
      (c) => c.countryShortCode === countryShortCode
    );
    return (
      country?.regions.map((r) => ({
        k: r.shortCode || r.name,
        v: r.name,
      })) || []
    );
  };

  return { countries, countryOptions, getProvinceOptions };
}
